const RETRY_DELAY_MS = 1000;
const MAX_RETRIES = 2;

/**
 * Wraps fetch with automatic retry on 5xx responses.
 * Azure Functions cold-start returns 500 for ~100-500ms after host restart.
 * A single retry after 1s is enough to survive that window.
 */
export async function fetchWithRetry(
    url: string,
    options?: RequestInit,
    retries: number = MAX_RETRIES
): Promise<Response> {
    const response = await fetch(url, options);

    if (response.status >= 500 && retries > 0) {
        await new Promise(r => setTimeout(r, RETRY_DELAY_MS));
        return fetchWithRetry(url, options, retries - 1);
    }

    return response;
}
